import { useAPI } from "@/api/api";
import { IFBeforeSetting } from "@/api/apiRsp/IFBeforeSetting";
import NiceModal from "@ebay/nice-modal-react";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import CommonPopup from "@/pages/commonPopup";
import { useGlobalState } from "./commonStore";
import { sys } from "@/Core/utils/system";
import FacebookCookies from "@/features/facebook/cookies";

/**
 * 配置接口
 */
export function useBeforeSetting(revalidateOnMount = true) {
  const { fbc, fbp } = FacebookCookies.getAllFacebookCookies();

  const { data, error, mutate, revalidate, isLoading } = useAPI<
    IFBeforeSetting,
    any
  >(
    {
      path: `api/index/setting?fbc=${fbc}&fbp=${fbp}`,
      type: "get"
    },
    null,
    {
      revalidateOnMount: revalidateOnMount
    }
  );
  const {
    customer,
    telegram,
    whatsapp,
    facebook,
    telegramChannel,
    telegramGroup,
    wnoticeVO,
    smsCodeFlag
  } = data || {};
  const { t } = useTranslationPlus("DownLoadApp");

  //========================== 客服 ==========================================
  const services = [];
  if (customer && customer.length) {
    services.push({
      type: "customer",
      url: customer,
      onClick: () => {
        sys.openUrl(customer);
      }
    });
  }
  if (telegram && telegram.length) {
    services.push({
      type: "telegram",
      url: telegram,
      onClick: () => {
        sys.openUrl(telegram);
      }
    });
  }
  if (telegramChannel && telegramChannel.length) {
    services.push({
      type: "telegramChannel",
      url: telegramChannel,
      onClick: () => {
        sys.openUrl(telegramChannel);
      }
    });
  }
  if (telegramGroup && telegramGroup.length) {
    services.push({
      type: "telegramGroup",
      url: telegramGroup,
      onClick: () => {
        sys.openUrl(telegramGroup);
      }
    });
  }
  if (whatsapp && whatsapp.length) {
    services.push({
      type: "whatsapp",
      url: whatsapp,
      onClick: () => {
        sys.openUrl(whatsapp);
      }
    });
  }
  if (facebook && facebook.length) {
    services.push({
      type: "facebook",
      url: facebook,
      onClick: () => {
        sys.openUrl(facebook);
      }
    });
  }
  const isMoreService = services.length > 1 ? true : false;
  const isStopService = wnoticeVO != null;

  //========================== 客服 ==========================================

  return {
    isStopService,
    data: data,
    errorCode: error?.code,
    mutate,
    revalidate,
    isLoading,
    error,
    isMoreService,
    services,
    smsCodeFlag
  };
}
